class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );

      // 🔥 ENTER FIX — pārņemam ENTER loģiku pilnībā
      this.input.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          this.forceSearchSubmit(e);
        }
      });
    }
  }

  // 🔥 PILNĀ ENTER LOĢIKA
  forceSearchSubmit(e) {
    const value = this.input.value.trim();
    const selected = document.querySelector('[aria-selected="true"] a');

    // Ja dropdownā ir izvēle → klikšķinam to
    if (selected) {
      e.preventDefault();
      selected.click();
      return;
    }

    // Ja nav ievadīts teksts → neļaujam sūtīt
    if (!value.length) {
      e.preventDefault();
      return;
    }

    // 🔥 Ja dropdown nefunkcionē → mēs paši veicam SEARCH:
    e.preventDefault();
    const url = `${window.routes.search_url}?q=${encodeURIComponent(value)}&options[prefix]=last`;
    window.location.href = url;
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    event.preventDefault();
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
